/**
 * Utility to transform null values to undefined in GraphQL responses
 * This provides TypeScript-friendly undefined values while keeping Apollo Client cache intact
 */

/**
 * Recursively transforms null values to undefined in an object
 * This aligns runtime values with TypeScript types generated with maybeValue: "T | undefined"
 */
export function transformNullToUndefined<T>(obj: T): T {
  if (obj === null) {
    return undefined as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => transformNullToUndefined(item)) as T;
  }

  if (typeof obj === "object" && obj !== null) {
    const record = obj as Record<string, unknown>;
    const transformed: Record<string, unknown> = {};

    for (const key in record) {
      if (Object.prototype.hasOwnProperty.call(record, key)) {
        transformed[key] = transformNullToUndefined(record[key]);
      }
    }

    return transformed as T;
  }

  return obj;
}
